import React from 'react';
import styles from './style.module.less';

const Quotes = () => {
  return <div className={styles.quotes}></div>;
};

export default Quotes;
